/* ==========================================================================
   TechNest — product-comparison.js
   Renders the comparison table for whatever the shopper has added to their
   compare list. The table markup comes from Liquid (compare-table-ajax), so
   prices and specification values are never assembled in JavaScript.
   ========================================================================== */
(function () {
  'use strict';

  const TN = window.TechNest || {};
  const utils = TN.utils;
  if (!utils || !TN.lists) return;

  class TnCompare extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-tn-compare-content]');
      this.emptyState = this.querySelector('[data-tn-compare-empty]');
      this.actions = this.querySelector('.tn-compare__actions');
      this.setAttribute('data-tn-product-list-root', '');
      this.reload();
      this._onChange = (event) => {
        if (event.detail && event.detail.key === 'compare') this.reload();
      };
      document.addEventListener('tn:list:change', this._onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('tn:list:change', this._onChange);
    }

    async reload() {
      const ids = TN.lists.compare.ids().slice(0, TN.settings.compareLimit || 4);

      if (!ids.length) {
        this.showEmpty();
        return;
      }

      const query = ids.map((id) => 'id:' + id).join(' OR ');
      const url =
        TN.routes.search +
        '?section_id=compare-table-ajax&type=product&q=' + encodeURIComponent(query) +
        '&tn_order=' + encodeURIComponent(ids.join(','));

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Compare fetch failed: ' + response.status);
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const table = parsed.querySelector('[data-tn-compare-table]');

        if (!table || !table.querySelector('table')) {
          this.showEmpty();
          return;
        }
        if (this.content) {
          this.content.innerHTML = table.innerHTML;
          this.content.hidden = false;
        }
        if (this.emptyState) this.emptyState.hidden = true;
        if (this.actions) this.actions.hidden = false;
      } catch (error) {
        this.showEmpty();
      }
    }

    showEmpty() {
      if (this.content) {
        this.content.innerHTML = '';
        this.content.hidden = true;
      }
      if (this.emptyState) this.emptyState.hidden = false;
      if (this.actions) this.actions.hidden = true;
    }
  }

  utils.define('tn-compare', TnCompare);
})();
